import { getdirectusUserFields } from "components/user/config";
import { addItemToCollection } from "directus/src/operations";

export async function createMeeting({ item }) {
  try {
    const query = {
      fields: [
        "id",
        "title",
        getdirectusUserFields("user_created"),
        "starts_at",
        "ends_at",
        "participants.id",
        "participants.participant.id",
        "participants.participant.email",
      ],
    };

    const data = await addItemToCollection("calendar_events", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
